export default __webpack_public_path__ + "static/partner_blocko-8e9d1299e7e31886b5c35110fb8193ab.png";